import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { MissingFormatWithOptions } from "./internal/MissingFormat.js";
import { TemporalUtils } from "./internal/TemporalUtils.js";
// While not used directly in this file, ensure patterns like 'LL', 'LT' et cetera work.
dayjs.extend(localizedFormat);
// While not used directly in this file, ensure patterns like 'z' and 'zzz' work.
dayjs.extend(advancedFormat);
export var DayjsFormat = /*#__PURE__*/ function() {
    "use strict";
    function DayjsFormat(options) {
        _class_call_check(this, DayjsFormat);
        Object.defineProperty(this, "pattern", {
            value: options.pattern
        });
    }
    var _proto = DayjsFormat.prototype;
    _proto.format = function format(value) {
        return TemporalUtils.toDayjs(value).format(this.pattern);
    };
    _proto.resolvedOptions = function resolvedOptions() {
        return {
            locale: dayjs.locale(),
            pattern: this.pattern
        };
    };
    return DayjsFormat;
}();
export var DayjsMissingFormat = /*#__PURE__*/ function(MissingFormatWithOptions) {
    "use strict";
    _inherits(DayjsMissingFormat, MissingFormatWithOptions);
    var _super = _create_super(DayjsMissingFormat);
    function DayjsMissingFormat(options) {
        _class_call_check(this, DayjsMissingFormat);
        return _super.call(this, new DayjsFormat(options), options);
    }
    return DayjsMissingFormat;
}(MissingFormatWithOptions);

//# sourceMappingURL=DayjsMissingFormat.js.map